import { SET_PRICE_GROUP } from './types';

export const setPriceGroup = group => ({
    type: SET_PRICE_GROUP,
    payload: group,
  });


// WEBPACK FOOTER //
// ./src/actions/app.actions.js